interface SectionHeadingProps {
  id?: string;
  eyebrow: string;
  title: string;
  description?: string;
  align?: 'left' | 'center';
}

export default function SectionHeading({
  id,
  eyebrow,
  title,
  description,
  align = 'left',
}: SectionHeadingProps) {
  const isCenter = align === 'center';
  return (
    <div className={isCenter ? 'max-w-3xl mx-auto text-center' : 'max-w-3xl'}>
      <span className="inline-flex items-center gap-2 text-xs md:text-sm font-medium tracking-wide text-primary-700 bg-primary-100 px-3 py-1 rounded-full">
        <i className="ri-bookmark-3-line w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
        {eyebrow}
      </span>
      <h2
        id={id}
        className="font-heading mt-3 text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 leading-snug scroll-mt-24"
      >
        {title}
      </h2>
      {description ? (
        <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-700">{description}</p>
      ) : null}
    </div>
  );
}